module.exports = __WEBPACK_EXTERNAL_MODULE_816__;


//////////////////
// WEBPACK FOOTER
// external "weaHrm"
// module id = 816
// module chunks = 1